"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechToTextWordResponseModelType = void 0;
exports.SpeechToTextWordResponseModelType = {
    Word: "word",
    Spacing: "spacing",
    AudioEvent: "audio_event",
};
